import React, {useEffect, useState} from 'react';
import {Switch, Route, Redirect, BrowserRouter} from 'react-router-dom';
import Login from './pages/login';
import Welcome from './pages/welcome';
// import Home from './pages/components/home/home'
import SocialAuth from './pages/socialAuth';
import {useDispatch, useSelector} from 'react-redux';
import SignUp from './pages/signUp';
import UserDetails from './pages/userDetails';
import Profile from './pages/components/profile/profile';
import Home from './pages/components/home/home';
import Lottie from 'react-lottie';
import HorizontalLoader from './imgs/horizontalprogressbar.json';
import {gql, useLazyQuery} from '@apollo/client';
import {SEARCH_PROFILE} from './graphql/query/profiles';
import {message} from 'antd';
import IntroCardInfo from './pages/components/MyBounties/IntroCardInfo';
import {currentUser} from './utils/helpers/currentUser';
import {setTokens} from './redux/actions/auth';
import {isEmpty} from 'lodash';
import MyBounties from './pages/components/MyBounties/MyBounties';
import BountyCardInfo from './pages/components/MyBounties/BountyCardInfo';
import ChatHome from './pages/components/Chat/ChatHome';
import Inbox from './pages/components/Chat/Inbox';
import Account from './pages/components/Account/Account';
import BountyCardCompleteDetail from './pages/components/MyBounties/BountyCardCompleteDetail';

const Router = (props) => {
  const {authToken, accessToken} = useSelector((state) => state.Auth);
  const strapiRes = useSelector((state) => state.strapiRes);
  const [signInCheck, setSignInCheck] = useState(false);
  const [authCheck, setAuthCheck] = useState(false);

  useEffect(() => {
    const signInCheck = Boolean(authToken && accessToken);
    setSignInCheck(signInCheck);
    const authCheck = Boolean(authToken && !accessToken);
    setAuthCheck(authCheck);
  }, [authToken, accessToken]);

  const [getUserByUserId] = useLazyQuery(gql(SEARCH_PROFILE), {
    fetchPolicy: 'network-only',
    onCompleted: (data) => queryCallBack(data),
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (authCheck && isEmpty(strapiRes)) {
      currentUser(authToken)
        .then(({email}) => {
          getUserByUserId({
            variables: {
              email: email,
            },
          });
        })
        .catch((error) => {
          message.error(error);
          localStorage.clear();
          dispatch(setTokens({authToken: null, accessToken: null}));
        });
    }
  }, [authCheck]);

  useEffect(() => {
    if (signInCheck && isEmpty(strapiRes)) {
      currentUser(authToken)
        .then(({email}) => {
          getUserByUserId({
            variables: {
              email: email,
            },
          });
        })
        .catch((error) => {
          message.error(error);
          localStorage.clear();

          dispatch(setTokens({authToken: null, accessToken: null}));
        });
    }
  }, [signInCheck]);

  const queryCallBack = ({searchProfileByEmail}) => {
    if (authCheck) {
      if (searchProfileByEmail?.length) {
        dispatch({
          type: 'SET_STRAPI_RES_DATA',
          payload: searchProfileByEmail[0],
        });
        localStorage.setItem('profileId', searchProfileByEmail[0].id);
        localStorage.setItem('email', searchProfileByEmail[0]?.email)
      } else {
        localStorage.setItem('accountType', 'custom');
        localStorage.setItem('accessToken', authToken);
        dispatch(
          setTokens({
            authToken: authToken,
            accessToken: authToken,
          }),
        );
      }
    }
  };

  return Boolean(Boolean(authCheck && isEmpty(strapiRes))) ? (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: HorizontalLoader,
        }}
        width={500}
      />
    </div>
  ) : (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path="/"
          render={(props) =>
            signInCheck ? (
              <Redirect exact to="/userdetails" />
            ) : authCheck ? (
              <Redirect exact to={`/${strapiRes.userName}`} />
            ) : (
              <Welcome {...props} />
            )
          }
        />
        <Route path="/home" component={Profile} />
        <Route
          path="/signup"
          render={(props) =>
            signInCheck ? (
              <Redirect exact to="/userdetails" />
            ) : authCheck ? (
              <Redirect exact to={`/${strapiRes.userName}`} />
            ) : (
              <SignUp {...props} />
            )
          }
        />
        <Route
          path="/login"
          exact
          render={(props) =>
            signInCheck ? (
              <Redirect exact to="/userdetails" />
            ) : authCheck ? (
              <Redirect exact to={`/${strapiRes.userName}`} />
            ) : (
              <Login {...props} />
            )
          }
        />
        <Route path="/auth/:id/callback" exact component={SocialAuth} />
        <PrivateRoute
          isAuthenticated={signInCheck}
          path="/userdetails"
          component={UserDetails}
          redirectLink={'/signup'}
        />
        <PrivateRoute
          isAuthenticated={authCheck}
          path="/mybounties"
          component={MyBounties}
          redirectLink={'/login'}
        />
        <PrivateRoute
          isAuthenticated={authCheck}
          path="/bountiesoffer"
          component={BountyCardInfo}
          redirectLink={'/login'}
        />
        <PrivateRoute
          isAuthenticated={authCheck}
          path="/bountiesoffercomplete"
          component={BountyCardCompleteDetail}
          redirectLink={'/login'}
        />
        <PrivateRoute
          isAuthenticated={authCheck}
          path="/introdetails"
          component={IntroCardInfo}
          redirectLink={'/login'}
        />
        <PrivateRoute
          isAuthenticated={authCheck}
          path="/chat"
          component={ChatHome}
          redirectLink={'/login'}
        />
        <PrivateRoute
          isAuthenticated={authCheck}
          path="/inbox"
          component={Inbox}
          redirectLink={'/login'}
        />
        <PrivateRoute
          isAuthenticated={authCheck}
          path="/bountydetails"
          component={BountyCardInfo}
          redirectLink={'/login'}
        />
        <PrivateRoute
          isAuthenticated={authCheck}
          path="/Account"
          component={Account}
          redirectLink={'/login'}
        />
          <PrivateRoute
          isAuthenticated={authCheck}
          path="/:username"
          component={Home}
          redirectLink={'/login'}
        />
      </Switch>
    </BrowserRouter>
  );
};

const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  redirectLink,
  ...rest
}) => (
  <Route
    {...rest}
    exact={true}
    render={(props) =>
      isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect to={redirectLink} exact />
      )
    }
  />
);

export default Router;